import React from 'react';

export const EraserSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 19.375H8.4375C8.35462 19.375 8.27513 19.3421 8.21653 19.2835C8.15792 19.2249 8.125 19.1454 8.125 19.0625C8.125 18.9796 8.15792 18.9001 8.21653 18.8415C8.27513 18.7829 8.35462 18.75 8.4375 18.75H17.5C17.5829 18.75 17.6624 18.7829 17.721 18.8415C17.7796 18.9001 17.8125 18.9796 17.8125 19.0625C17.8125 19.1454 17.7796 19.2249 17.721 19.2835C17.6624 19.3421 17.5829 19.375 17.5 19.375Z"
      fill="#EA8986"
    />
    <path
      d="M19.1536 6.21156L14.1008 1.15874C13.9316 0.98953 13.7308 0.855299 13.5098 0.763718C13.2887 0.672137 13.0518 0.625 12.8125 0.625C12.5732 0.625 12.3363 0.672137 12.1153 0.763718C11.8942 0.855299 11.6934 0.98953 11.5242 1.15874L0.846409 11.8366C0.505262 12.1785 0.313675 12.6418 0.313675 13.1249C0.313675 13.6079 0.505262 14.0712 0.846409 14.4132L5.71657 19.2834C5.77516 19.342 5.85463 19.375 5.9375 19.375H8.4375C8.52038 19.375 8.59985 19.342 8.65844 19.2834L19.1536 8.78815C19.4947 8.44619 19.6863 7.98288 19.6863 7.49985C19.6863 7.01683 19.4947 6.55352 19.1536 6.21156V6.21156Z"
      fill="#F2A8A6"
    />
    <path
      d="M12.8125 0.625007C12.5731 0.624333 12.336 0.671162 12.1149 0.762783C11.8937 0.854403 11.6929 0.988994 11.5242 1.15876L2.37053 10.3125L10 17.9419L19.1536 8.78816C19.4947 8.44621 19.6863 7.9829 19.6863 7.49987C19.6863 7.01684 19.4947 6.55353 19.1536 6.21157L14.1008 1.15876C13.9321 0.988994 13.7313 0.854403 13.5101 0.762783C13.289 0.671162 13.0519 0.624333 12.8125 0.625007V0.625007Z"
      fill="#EA8986"
    />
    <path
      d="M4.24458 12.1873L14.685 1.74686L18.5638 5.62563L8.12336 16.066L4.24458 12.1873Z"
      fill="#EA8986"
    />
  </svg>
);

export default EraserSvg;
